import * as React from 'react';
import { t } from 'i18next';

import { SelectBoxStoreState, SelectBoxStore, SelectBoxOption } from '../../stores/SelectBoxStore';
import { BaseHamburgerTab } from './BaseHamburgerTab';
import { HamburgerTab } from '../../constants/Enums';
import { SelectBoxActions } from '../../actions/SelectBoxActions';
import { UIHelper } from '../../utils/UIHelper';
import { HoverTimeout, LayoutType } from '../../constants/LayoutConstants';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { HamburgerContentWrapper } from './HamburgerContentWrapper';

export class SettingsOptionsTab extends BaseHamburgerTab<SelectBoxStoreState> {
    protected previous: HamburgerTab = HamburgerTab.SETTINGS;

    public componentWillMount(): void {
        this.addStoreListener(SelectBoxStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (this.state.options.length > 0 && !this.state.asOverlay) {
            return (
                <HamburgerContentWrapper className={this.getCSSClass()} header={this.header()}>
                    {this.custom()}
                    <div className="long-button-group">
                        {this.state.options.map(this.getOption)}
                    </div>
                </HamburgerContentWrapper>
            );
        }
        return null;
    }

    protected getOption = (selectOption: SelectBoxOption, index: number) => {
        if (selectOption.name === 'separator') {
            return null;
        }
        return (
            <div
                key={index}
                className="long-button-background"
                onClick={this.onClick(selectOption.value, selectOption.callback)}
            >
                <div
                    className={
                        'long-button short-border with-check' +
                        ((this.state.value === selectOption.value) ? ' checked' : '')
                    }
                >
                    {selectOption.name}
                </div>
            </div>
        );
    };

    protected getLabel(): string {
        return this.state.title;
    }

    protected onChange = (): void => {
        this.setState(SelectBoxStore.getState());
    };

    protected closeSelect(event?: React.MouseEvent): void {
        SelectBoxActions.closeSelectBox();
        if (event != null) {
            UIHelper.stopEvent(event);
        }
    }

    protected onClick = (value: any, callback?: () => void) => (event: React.MouseEvent) => {
        this.setState(jQuery.extend({}, SelectBoxStore.getState(), {value: value}));
        if (callback) {
            callback();
        }
        UIHelper.stopEvent(event);
        window.setTimeout(
            () => {this.closeSelect(); },
            HoverTimeout
        );
    };

    protected back = (): void => {
        this.closeSelect();
    };

    protected custom = (): JSX.Element | null => {
        if (
            this.state.sender === 'sidebarposition-select' &&
            this.props.layoutType === LayoutType.SMALL &&
            AppConfigurationStore.getState().inApp
        ) {
            return (
                <div className="sidebar-subheader">{t('Direction in landscape mode')}</div>
            );
        }
        return null;
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/SettingsOptionsTab.tsx